import axios from "../../utils/axios";

export const getRelatedPosts = async (postId) => {
  const response = await axios.get(`/blogs?id_ne=${postId}&_sort=likes&_order=desc`);
  return response.data;
};
